<template>
  <h2 class="is-uppercase has-text-weight-bold mb-2" style="cursor: pointer" v-on:click="onToggleVisibility()">
    <button class="card-header-icon" style="display: contents">
      <span class="icon" v-bind:class="{'is-hidden' : !isVisible}">
        <i class="fas fa-angle-down"></i>
      </span>
      <span class="icon" v-bind:class="{'is-hidden' : isVisible}">
        <i class="fas fa-angle-right"></i>
      </span>
    </button>
    &nbsp;
    Наши преподаватели
  </h2>
  <div class="tile is-ancestor is-desktop mb-5" v-if="isVisible">
    <TeacherCard v-for='(teacher, i) in teachers' :key="i" class="teacher" v-bind:teacher="teacher">
    </TeacherCard>
  </div>
</template>

<script>
import TeacherCard from "./TeacherCard";

export default {
  name: 'Teachers',
  data() {
    return {
      teachers: window.vueData.teachers,
      isVisible: false,
    }
  },
  methods: {
    onToggleVisibility: function () {
      this.isVisible = !this.isVisible;
    },
  },
  components: {
    TeacherCard
  }
}
</script>